import { render, staticRenderFns } from "./addrequisition.vue?vue&type=template&id=4955781e&scoped=true&"
import script from "./addrequisition.vue?vue&type=script&lang=js&"
export * from "./addrequisition.vue?vue&type=script&lang=js&"
import style0 from "./addrequisition.vue?vue&type=style&index=0&id=4955781e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4955781e",
  null
  
)

export default component.exports